import { Currency, Pair } from '@uniswap/sdk'
import React, { useState, useContext, useCallback, useEffect } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { darken } from 'polished'
import { useCurrencyBalance } from '../../state/wallet/hooks'
import CurrencySearchModal from '../SearchModal/CurrencySearchModal'
import CurrencyLogo from '../CurrencyLogo'
import DoubleCurrencyLogo from '../DoubleLogo'
import { RowBetween } from '../Row'
import { TYPE } from '../../theme'
import { Input as NumericalInput } from '../NumericalInput'
import { ReactComponent as DropDown } from '../../assets/images/dropdown.svg'
import { ReactComponent as ArrowRight } from '../../assets/images/arrowright.svg'

import { useActiveWeb3React } from '../../hooks'
import { useTranslation } from 'react-i18next'
import Box from '@material-ui/core/Box'

const InputRow = styled.div<{ selected: boolean }>`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 60px;
  /* margin-bottom: 28px; */
  padding: ${({ selected }) => (selected ? '0.75rem 0.5rem 0.75rem 1rem' : '0.75rem 0.75rem 0.75rem 1rem')};
`

const CurrencySelect = styled.button<{ selected: boolean }>`
  align-items: center;
  /* height: 2.2rem; */
  font-size: 20px;
  width: 100%;
  height: 65px;
  font-weight: 500;
  background-color: '#1F1F1F';
  color: ${({ selected, theme }) => (selected ? theme.text1 : theme.black)};
  border-radius: 12px;
  box-shadow: ${({ selected }) => (selected ? 'none' : '0px 6px 10px rgba(0, 0, 0, 0.075)')};
  outline: none;
  cursor: pointer;
  user-select: none;
  border: none;
  /* padding: 0 0.5rem; */
  padding: 10px;
  background-color: ${({ selected, theme }) => (selected ? theme.bg2 : darken(0.05, theme.primary4))};
    color:"black";

  :focus,
  :hover {
    background-color: ${({ selected, theme }) => (selected ? theme.bg2 : darken(0.05, theme.primary4))};
    opacity: ${({ selected, theme }) => (selected ? 1 : 0.8)};
  }
  @media (max-width: 768px) {
    font-size: 11px;
  }
`

const LabelRow = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  color: ${({ theme }) => theme.text1};
  font-size: 0.75rem;
  line-height: 1rem;
  padding: 0.75rem 1rem 0 1rem;
  span:hover {
    cursor: pointer;
    color: ${({ theme }) => darken(0.2, theme.text2)};
  }
`

const Aligner = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const StyledDropDown = styled(ArrowRight) <{ selected: boolean }>`
  margin: 0 0.25rem 0 0.5rem;
  height: 35%;

  path {
    stroke: ${({ selected, theme }) => (selected ? theme.text1 : theme.black)};
    stroke-width: 1.5px;
  }
`

const InputPanel = styled.div<{ hideInput?: boolean }>`
  ${({ theme }) => theme.flexColumnNoWrap}
  position: relative;
  border-radius: ${({ hideInput }) => (hideInput ? '8px' : '10px')};
  background-color: #1F1F1F;
  z-index: 1;
`

const Container = styled.div<{ hideInput: boolean }>`
  border-radius: ${({ hideInput }) => (hideInput ? '8px' : '10px')};
  // border: 1px solid #1F1F1F;
  background-color: #1F1F1F;
`

const StyledTokenName = styled.span<{ active?: boolean }>`
  ${({ active }) => (active ? '  margin: 0 0.25rem 0 0.05rem;' : '  margin: 0 0.25rem 0 0.25rem;')}
  font-size:  ${({ active }) => (active ? '15px' : '15px')};
  /* color: black; */
  @media (max-width: 768px) {
    font-size: 11px;
    text-wrap: nowrap;
  }

`

const StyledBalanceMax = styled.button`

  background-color: ${({ theme }) => theme.bg2};
  border: 1px solid ${({ theme }) => theme.bg6};
  border-radius: 5px;
  font-size: 0.64rem;
  padding: 2px 3px;

  font-weight: 500;
  cursor: pointer;
  margin-right: 0.5rem;
  color: ${({ theme }) => theme.bg6};
  :hover {
    border: 1px solid ${({ theme }) => theme.primary1};
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin-right: 0.5rem;
  `};

`

interface CurrencyInputPanelProps {
    value: string
    onUserInput: (value: string) => void
    onMax?: () => void
    showMaxButton: boolean
    label?: string
    onCurrencySelect?: (currency: Currency) => void
    currency?: Currency | null
    disableCurrencySelect?: boolean
    hideBalance?: boolean
    pair?: Pair | null
    hideInput?: boolean
    otherCurrency?: Currency | null
    id: string
    showCommonBases?: boolean
    customBalanceText?: string
}

export default function CurrencyInputPanel({
    value,
    onUserInput,
    onMax,
    showMaxButton,
    label = 'Input',
    onCurrencySelect,
    currency,
    disableCurrencySelect = false,
    hideBalance = false,
    pair = null, // used for double token logo
    hideInput = false,
    otherCurrency,
    id,
    showCommonBases,
    customBalanceText
}: CurrencyInputPanelProps) {
    const { t } = useTranslation()

    const [modalOpen, setModalOpen] = useState(false)
    const { account } = useActiveWeb3React()
    const selectedCurrencyBalance = useCurrencyBalance(account ?? undefined, currency ?? undefined)
    const theme = useContext(ThemeContext)

    const handleDismissSearch = useCallback(() => {
        setModalOpen(false)
    }, [setModalOpen])
    // useEffect(()=>{
    //     console.log('currency', currency);
    // }, [currency])
    return (
        <InputPanel id={id}>
            <Container hideInput={hideInput}>
                {/* {!hideInput && (
                    <LabelRow>
                        <RowBetween>
                            <TYPE.body color={theme.text2} fontWeight={500} fontSize={14}>
                                {label}
                            </TYPE.body>

                        </RowBetween>
                    </LabelRow>
                )} */}
                <InputRow style={hideInput ? { padding: '0', borderRadius: '8px' } : {}} selected={disableCurrencySelect}>
                    <Box className='flex flex-col gap-1 w-full'>
                        <CurrencySelect
                            selected={!!currency}
                            className="open-currency-select-button"
                            onClick={() => {
                                if (!disableCurrencySelect) {
                                    setModalOpen(true)
                                }
                            }}
                        >
                            <Aligner>
                                {pair ? (
                                    <DoubleCurrencyLogo currency0={pair.token0} currency1={pair.token1} size={45} margin={true} />
                                ) : currency ? (
                                    <CurrencyLogo currency={currency} size={'45px'} />
                                ) : null}
                                {pair ? (
                                    <StyledTokenName className="pair-name-container">
                                        {pair?.token0.symbol}:{pair?.token1.symbol}
                                    </StyledTokenName>
                                ) : (
                                    <StyledTokenName className="token-symbol-container" active={Boolean(currency && currency.symbol)}>
                                        {(currency && currency.symbol && currency.symbol.length > 20
                                            ? currency.symbol.slice(0, 4) +
                                            '...' +
                                            currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length)
                                            : currency?.symbol) || 'Select a Token'}
                                    </StyledTokenName>
                                )}
                                {!disableCurrencySelect && <StyledDropDown selected={!!currency} />}
                            </Aligner>

                        </CurrencySelect>
                        <Box className='flex justify-center gap-2 items-center'>
                            <Box>
                                {account && (
                                    <TYPE.body
                                        onClick={onMax}
                                        color={theme.text2}
                                        fontWeight={500}
                                        fontSize={14}
                                        style={{ display: 'inline', cursor: 'pointer' }}
                                    >
                                        {!hideBalance && !!currency && selectedCurrencyBalance
                                            ? (customBalanceText ?? 'Balance: ') + selectedCurrencyBalance?.toSignificant(6)
                                            : ' Balance: '}
                                    </TYPE.body>
                                )}
                            </Box>
                            <Box>
                                {account && (
                                    <StyledBalanceMax onClick={onMax}>MAX</StyledBalanceMax>
                                )}
                            </Box>
                        </Box>
                    </Box>
                    {!hideInput && (
                        <>
                            <NumericalInput
                                className="token-amount-input"
                                value={value}
                                onUserInput={val => {
                                    onUserInput(val)
                                }}
                            />

                        </>
                    )}

                </InputRow>
            </Container>
            {!disableCurrencySelect && onCurrencySelect && (
                <CurrencySearchModal
                    isOpen={modalOpen}
                    onDismiss={handleDismissSearch}
                    onCurrencySelect={onCurrencySelect}
                    selectedCurrency={currency}
                    otherSelectedCurrency={otherCurrency}
                    showCommonBases={showCommonBases}
                />
            )}
        </InputPanel>
    )
}
